/**
 * Request headers used in Planner service requests.
 */ export var RequestHeaders = /*#__PURE__*/ function(RequestHeaders) {
    /** Header to specify the Trouter subscription endpoint for the query */ RequestHeaders["TrouterSubscriptionEndpoint"] = "X-Tasks-Subscribe-TrouterEndpoint";
    return RequestHeaders;
}({});
/**
 * Response headers used in Planner service responses.
 */ export var ResponseHeaders = /*#__PURE__*/ function(ResponseHeaders) {
    /** Header specifying the Trouter view update key for the response (success or failure) */ ResponseHeaders["TrouterViewUpdateKey"] = "X-Tasks-Subscribe-TrouterViewUpdateKey";
    return ResponseHeaders;
}({});
